module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main confirm"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('prices-confirm-title1')) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.username) + "(" + _vm._s(_vm.account) + ")")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('prices-confirm-title2')) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.paymentPlan))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('prices-confirm-title3')) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('prices-confirm-title4')) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.paymentWayTransfer))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pay"
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v(_vm._s(_vm.$t('prices-confirm-title5')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPaying),
      expression: "isPaying"
    }],
    staticClass: "payment-dialog"
  }, [_c('div', {
    staticClass: "dialog-main"
  }, [_c('div', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.$t('prices-confirm-title6')))]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.$t('prices-confirm-title7')))]), _vm._v(" "), _c('div', {
    staticClass: "payment-result"
  }, [_c('span', {
    staticClass: "unComplete",
    on: {
      "click": _vm.pay
    }
  }, [_vm._v(_vm._s(_vm.$t('prices-confirm-title8')))]), _vm._v(" "), _c('span', {
    staticClass: "complete",
    on: {
      "click": _vm.paySuccessfully
    }
  }, [_vm._v(_vm._s(_vm.$t('prices-confirm-title9')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1149caea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/Confirm.vue
// module id = 292
// module chunks = 1